import { Component, OnInit } from '@angular/core';
import { OfbizForm,OfbizList } from '@urbannex/ofbiz-forms';
import { UbsComponentStoreService } from '../ubs-component-store.service';

@Component({
  selector: 'ubs-find-container',
  templateUrl: './find-container.component.html',
  styleUrls: ['./find-container.component.scss']
})
export class FindContainerComponent implements OnInit {
  findForm:OfbizForm;
  //options:any = {};
  title:string;

  listForm:OfbizList;
  fieldOptions:any = {};
  listOptions:any = {};
  listTitle = "Results";
  state:any;

  constructor(private componentStore:UbsComponentStoreService) { }

  ngOnInit(): void {
    this.componentStore.vm$.subscribe(data => {
      this.state = data;
      switch (data.workSpaceState) {
        case "Content":
          //console.log("Finding Fucking Content");
          this.title = "Find Content"
          break;
        case "Survey":
          //console.log("Finding Fucking Surveys");
          this.title = "Find Survey"  
          break;
        case "Websites":
          //console.log("Finding Fucking Websites");
          //console.log(data.cmsComponentConfig.findForm);  
          this.title = "Find Web Site"
          break;
        case "Data Resource":
          //console.log("Finding Fucking Data Resource");  
          this.title = "Find Data Resource"
          break;
      
        default:
          break;
      }
      this.findForm = data.componentConfig.findForm;
     });
  }

}
